// @ts-strict-ignore
import { Box3, Euler, Object3D } from 'three';
import { MeshUtils } from '@3d-scene/common/util/mesh-utils';
import { Object3DUtils } from '../common/util/object-3d-utils';

export class BaseContainer3D extends Object3D {

  protected _bounds: Box3 = null;

  /**
   * Moves the 3d object directly to a point in space
   */
  public moveTo(dx: number, dy: number, dz: number): void {
    this.position.set(dx, dy, dz);
    this.updateMatrixWorld(true);
  }

  public moveBy(dx: number, dy: number, dz: number): void {
    this.moveTo(this.position.x + dx, this.position.y + dy, this.position.z + dz);
  }

  public rotateByEuler(rotation: Euler): void {
    MeshUtils.rotateByEuler(this, rotation);
    this.updateMatrixWorld(true);
  }

  public inverseRotateByEuler(rotation: Euler): void {
    MeshUtils.inverseRotateByEuler(this, rotation);
    this.updateMatrixWorld(true);
  }

  public rotateToInReversedOrder(rX: number, rY: number, rZ: number): void {
    MeshUtils.rotateInReversedOrder(this, rX, rY, rZ);
    this.updateMatrixWorld(true);
  }

  public dispose(): void {
    if (this.parent) {
      this.parent.remove(this);
    }
  }

  public invalidateBounds(): void {
    this._bounds = null;
  }

  public get bounds(): Box3 {
    if (!this._bounds) {
      this.updateBounds();
    }
    return this._bounds;
  }

  protected updateBounds(): void {
    throw new Error('updateBounds() is not implemented in current class!');
  }

  public get sceneTransformBounds(): Box3 {
    return Object3DUtils.transformBounds(this.bounds, this.matrixWorld);
  }
}
